import { Template } from "@/lib/types";
import { useEffect, useState } from "react";
import { renderImageFromCanvasData } from "../utils/renderUtils";

export function useImageFromFabricData(data?: Template["canvas_data"], options?: { multiplier: number }) {
  const [image, setImage] = useState("");
  const multiplier = options?.multiplier ?? 0.5;

  useEffect(() => {
    let shouldUpdate = true;

    const setDataUrlImage = async (canvasData: Template["canvas_data"]) => {
      const dataUrl = await renderImageFromCanvasData(canvasData, { multiplier });

      // Don't update if component is unmounted or dataUrl is not available
      if (!shouldUpdate || !dataUrl) return;

      setImage(dataUrl);
    };

    if (data) {
      void setDataUrlImage(data);
    }

    return () => {
      shouldUpdate = false;
    };
  }, [data, multiplier]);

  return image;
}
